// layouts/MainLayout/components/Navbar/Navbar.tsx
import { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../../contexts/AuthContext';
import { useTheme } from '../../../../contexts/ThemeContext';
import styles from './Navbar.module.css';
import DigiBrigiLogo from '../../../../components/common/DigiBrigiLogo/DigiBrigiLogo';

const NAV_LINKS: { id: string; label: string }[] = [
  // { id: 'how', label: 'Jak to funguje' },
  // { id: 'try', label: 'Demo' },
  // { id: 'pricing', label: 'Členství' },
  // { id: 'features', label: 'Co získáš' },
  // { id: 'faq', label: 'FAQ' },
];

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { user } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const menuRef = useRef<HTMLDivElement | null>(null);

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsMobileMenuOpen(false);
      }
    };
    if (isMobileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMobileMenuOpen]);

  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const scrollToSection = (sectionId: string) => {
    const scroll = () => {
      const element = document.getElementById(sectionId);
      if (element) element.scrollIntoView({ behavior: 'smooth' });
    };
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(scroll, 100);
    } else {
      scroll();
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={styles.navbar}>
      <div className={styles.inner}>
        <DigiBrigiLogo size={22} onClick={() => navigate('/')} />

        <div ref={menuRef} className={styles.right}>
          <ul className={`${styles.navLinks} ${isMobileMenuOpen ? styles.mobileOpen : ''}`}>
            {NAV_LINKS.map((link) => (
              <li key={link.id}>
                <button className={styles.navLink} onClick={() => scrollToSection(link.id)}>
                  {link.label}
                </button>
              </li>
            ))}
            <li>
              <button className={styles.themeToggle} onClick={toggleTheme} aria-label="Změnit téma">
                {theme === 'light' ? '🌙' : '☀️'}
              </button>
            </li>
            <li>
              {user ? (
                <Link to="/dashboard" className={styles.navCta}>
                  Dashboard
                </Link>
              ) : (
                <button
                  className={styles.navCta}
                  onClick={() => {
                    navigate("/login")
                  }}
                >
                  Přihlásit se
                </button>
              )}
            </li>
          </ul>

          <button
            className={`${styles.burger} ${isMobileMenuOpen ? styles.active : ''}`}
            onClick={() => setIsMobileMenuOpen((o) => !o)}
            aria-label="Menu"
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
